import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import { HashNavigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import CreditsBalanceHeader from '../../components/CreditsBalanceHeader/CreditsBalanceHeader';
import AppConfig from '../../config';
import useBackButton from '../../hooks/useBackButton';
import StorageService from '../../services/StorageService';
import PortfolioTemplate from './components/PortfolioTemplate';

import './Portfolio.scss';

const { routes } = AppConfig;

const SLIDES_PER_VIEW = 1.1;

const getBodyTranslateSizes = (progress = 0, slidesGrid = []) => {
	const maxBodyTranslate = ((SLIDES_PER_VIEW - 1) / 2) * 100;
	const slideSize = 1 / (slidesGrid.length - 1);

	return slidesGrid.map((_, index) => {
		const slideBodyTranslate = ((slideSize * index - progress) * maxBodyTranslate) / slideSize;
		return Math.max(-maxBodyTranslate, Math.min(slideBodyTranslate, maxBodyTranslate));
	});
};

const Portfolio = () => {
	const [bodyTranslateSizes, setBodyTranslateSizes] = useState([]);

	const navigate = useNavigate();
	useBackButton(false);

	useEffect(() => {
		StorageService.UpdateBillingBalance();
	}, []);

	const goBillingPage = () => {
		navigate({ pathname: routes.billingHistory });
	};

	const onProgress = (progressData, progress) => {
		setBodyTranslateSizes(getBodyTranslateSizes(progress, progressData?.slidesGrid));
	};

	return (
		<div className='Portfolio'>
			<CreditsBalanceHeader topUpAction={goBillingPage} />
			<Swiper
				className='Portfolio__swiper'
				onProgress={onProgress}
				watchSlidesProgress={true}
				slidesPerView={SLIDES_PER_VIEW}
				centeredSlides={true}
				hashNavigation={{ watchState: true, replaceState: true }}
				modules={[HashNavigation]}
			>
				<SwiperSlide data-hash={'crypto'}>
					<PortfolioTemplate portfolioId={'crypto'} bodyTranslate={bodyTranslateSizes[0]} />
				</SwiperSlide>
			</Swiper>
		</div>
	);
};

export default Portfolio;
